import { render } from "./Juvenil.vue?vue&type=template&id=3e01e680&scoped=true"
import script from "./Juvenil.vue?vue&type=script&lang=js"
export * from "./Juvenil.vue?vue&type=script&lang=js"

import "./Juvenil.vue?vue&type=style&index=0&id=3e01e680&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e01e680"]])

export default __exports__